import React from 'react';
import { PageSection, ListFieldSection } from '../Layout';
import { Field, TextInput } from '../Core';

const ClientUrisAdmin = () => (
  <PageSection>
    <ListFieldSection single>
      <Field label="QESTField" input={<TextInput />} name="syncModel.QestFieldUri" />
      <Field label="QEST Web App" input={<TextInput />} name="syncModel.QestWebAppUri" />
    </ListFieldSection>
  </PageSection>
);

export default ClientUrisAdmin;
export { ClientUrisAdmin };
